export const STATUS_VARIANT_MAP: Record<
	string,
	'default' | 'secondary' | 'destructive' | 'outline'
> = {
	open: 'outline',
	planned: 'secondary',
	in_progress: 'secondary',
	completed: 'default',
	rejected: 'destructive',
};
